import $ from 'jquery';
import '@fancyapps/fancybox';
$('.callback--js').on('click', function (event) {
	event.preventDefault();
	$.fancybox.open({
		loop: false,
		src: '#callback-modal',
		baseClass: 'dark-fancybox',
		touch: false,
		afterLoad : function(){
			$(".fancybox-content").addClass('fadeInDown animated');
		},
		beforeClose : function(){
			$(".fancybox-content").removeClass('fadeInDown animated');
		}
	});
});

$('.summary--js').on('click', function (event) {
	event.preventDefault();
	$.fancybox.open({
		loop: false,
		src: '#summary-modal',
		baseClass: 'summary-fancybox',
		touch: false,
	});
});

$('.download--js').on('click', function (event) {
	event.preventDefault();
	$.fancybox.open({
		loop: false,
		src: '#download-report',
		baseClass: 'download-fancybox',
		touch: false,
	});
});